import React from "react";
import TextField from "@mui/material/TextField";

const TaxIdWidget = (props) => {
  const { id, value, required, disabled, readonly, autofocus, onChange, onBlur, onFocus, options, schema, label } =
    props;

  const handleChange = (event) => {
    // Block user from inputting any non numerics
    let input = event.target.value.replace(/\D/g, "");

    onChange(input || undefined);
  };

  return (
    <TextField
      id={id}
      label={label || schema.title}
      value={value || ""}
      required={required}
      disabled={disabled}
      readOnly={readonly}
      autoFocus={autofocus}
      onChange={handleChange}
      onBlur={onBlur && ((event) => onBlur(id, event.target.value))}
      onFocus={onFocus && ((event) => onFocus(id, event.target.value))}
      placeholder={options.placeholder || "123456789"}
      fullWidth
      variant="outlined"
      size="small"
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{
        minLength: 9,
        maxLength: 9,
      }}
    />
  );
};

export default TaxIdWidget;
